import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d806798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "div-margin-top" }
const _hoisted_2 = { align: "" }
const _hoisted_3 = { key: 0 }


import { defineComponent, onMounted } from 'vue'
import { getI18n } from '../utils'
import { mainDomain } from '../config'
const __default__ = defineComponent({
  name: 'HelpCenter'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

onMounted(async () => {
  console.log('enter')
})

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_image, { src: './images/banner01.png' }, null, 8, ["src"]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, _toDisplayString(_unref(getI18n)("到达目的地套餐自动激活", 'Automatic activation of package upon arrival at destination')), 1),
      _createElementVNode("li", null, _toDisplayString(_unref(getI18n)("请切换到我们的卡，打开漫游，如果不能联网，关闭打开飞行模式试试，或重启手机", 'Please switch to our SIM card, turn on roaming, and if you cannot connect to the network, try turning airplane mode on/off, restart your phone')), 1),
      _createElementVNode("li", null, _toDisplayString(_unref(getI18n)("APN 是 cmlink", 'APN is cmlink')), 1),
      _createElementVNode("li", null, _toDisplayString(_unref(getI18n)("随时可以充值", "Recharge data at any time.")), 1),
      _createElementVNode("li", null, _toDisplayString(_unref(getI18n)("支持100多个国家，一卡走遍世界", "Supports over 100 countries; one card for the world.")), 1),
      _createElementVNode("li", null, [
        _createVNode(_component_el_link, {
          type: "primary",
          href: '/helper/install/android'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getI18n)("安卓安装ESIM", 'Installing ESIM on Android')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_el_link, {
          type: "primary",
          href: '/helper/install/apple'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getI18n)("苹果安装ESIM", 'Installing ESIM on Apple')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_el_link, {
          type: "primary",
          href: '/helper/support-device'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getI18n)("适用机型", 'Compatible Devices')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_el_link, {
          type: "primary",
          href: '/helper/carrier'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getI18n)("运营商列表", 'Carrier List')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_el_link, {
          type: "primary",
          href: "/helper/faq/zh"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getI18n)("FAQ", 'FAQ')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_el_link, {
          type: "primary",
          href: "https://global.cmlink.com/store/realname"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getI18n)("香港、台湾需要实名认证", 'Hong Kong and Taiwan require real-name registration')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (_unref(mainDomain)=='cddata.xyz')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(getI18n)('客服邮箱：', 'Guest service E-mail:')) + " sales@zhonglongtech.com ", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})